import { useEffect, useState } from 'react';
import { ChevronLeft } from 'lucide-react';
import {
  subscribeInAppBack,
  hasInAppBack,
  triggerInAppBack,
  isStandalonePWA,
} from '@/lib/telegram-service';

/**
 * Tasto "indietro" in-app per la PWA installata (standalone).
 * In Telegram si usa il BackButton nativo; in PWA non esiste, quindi qui
 * mostriamo una freccia flottante pilotata dallo stesso stack di
 * showBackButton/hideBackButton (telegram-service). Nessun call site cambia.
 * Visibile SOLO in standalone e solo quando c'è un handler back attivo.
 */
export function InAppBackButton() {
  const [standalone] = useState(() => isStandalonePWA());
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!standalone) return;
    const update = () => setVisible(hasInAppBack());
    update();
    return subscribeInAppBack(update);
  }, [standalone]);

  if (!standalone || !visible) return null;

  return (
    <button
      type="button"
      aria-label="Indietro"
      onClick={() => triggerInAppBack()}
      className="fixed left-3 z-[10001] flex items-center justify-center w-10 h-10 rounded-full bg-black/55 backdrop-blur-md border border-white/15 text-white active:scale-95 transition-transform"
      style={{ top: 'calc(var(--safe-top) + 8px)' }}
    >
      <ChevronLeft className="w-6 h-6" />
    </button>
  );
}

export default InAppBackButton;
